import { useEffect } from 'react'

export const usePreventWheelOnNumberInput = () => {
  useEffect(() => {
    const preventWheelOnNumberInput = (event: WheelEvent) => {
      const target = event.target
      if (!(target instanceof HTMLInputElement)) return
      if (target.type !== 'number') return
      if (document.activeElement !== target) return

      event.preventDefault()
      target.blur()
    }

    document.addEventListener('wheel', preventWheelOnNumberInput, {
      capture: true,
      passive: false,
    })

    return () => {
      document.removeEventListener('wheel', preventWheelOnNumberInput, true)
    }
  }, [])
}
